import { Injectable } from '@angular/core'
import { Http, Response, URLSearchParams } from '@angular/http'
import { Angular2TokenService } from 'angular2-token'

import { Store } from "@ngrx/store"
import { AppState } from "@store/app-state"
import { Term } from "@models/term"
import { PublicHoliday } from "@models/public-holiday"
import { Observable } from 'rxjs'
import { ActionCableService } from "./action-cable"
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'

@Injectable()
export class PublicHolidayService {

  private publicHolidaysUrl: string = 'public_holidays'

  constructor(
    private http: Angular2TokenService,
    private actionCableService: ActionCableService,
    private store: Store<AppState>,
  ) {}

  create(params: any): Observable<PublicHoliday> {
    return this.http.post(this.publicHolidaysUrl, params)
      .map((res: Response) => PublicHoliday.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  update(params: any): Observable<PublicHoliday> {
    return this.http.patch(`${this.publicHolidaysUrl}/${params.id}`, params)
      .map((res: Response) => PublicHoliday.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  destroy(id: number): Observable<boolean> {
    return this.http.delete(`${this.publicHolidaysUrl}/${id}`)
      .map(() => true)
      .catch((error: Response) => Observable.throw(error.json()))
  }

}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/public-holiday.ts